import type { RouteObject } from 'react-router-dom';
import EditStaff from './details/edit-staff.tsx';
import NewStaff from './details/new-staff.tsx';
import StaffListWrapper from './list/staff-list-wrapper.tsx';
import Staff from './Staff';

export const staffRoute = {
  path: '/staff',
  element: <Staff />,
  children: [
    {
      path: 'new',
      element: <NewStaff />,
    },
    {
      path: 'edit/:key',
      element: <EditStaff />,
    },
    {
      path: '',
      element: <StaffListWrapper />,
    },
  ],
} as RouteObject;

export default Staff;
